module.exports = "<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 12.6 15.1\" enable-background=\"new 0 0 12.6 15.1\" xml:space=\"preserve\"><rect class=\"control-svg\" x=\"7.8\" y=\"0\" fill=\"#000111\" width=\"4.8\" height=\"15.1\"></rect><rect class=\"control-svg\" x=\"0\" y=\"0\" fill=\"#000111\" width=\"4.8\" height=\"15.1\"></rect></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/ui/icons/pause.svg
// module id = 846
// module chunks = asvp